module.exports = __webpack_public_path__ + "img/PVMonitoringService.f794b80a.png";